import { forwardRef, useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import Modal, { Content, Header, Footer } from "../modal";
import dict from 'skin/store/dict';
import Button from "../button";
import Item from "./item";

const Dict = forwardRef(({ value, onSelect, data, code, close, info=null }, ref) => {
	const [state, setState] = useState(value);
	const submit = useCallback(() => {
		onSelect(state);
		close();
	}, [state, onSelect, close]);
	const title = dict.s?.title;
	const wait = data.wait?.on;
	useEffect(() => {
		dict.getData(code, info, true);
	}, []);
	return <Modal ref={ref} onClose={close} showClose>
		{title ? <Header children={title} /> : null}
		<Content>
			{
				wait
				? <span style={{textAlign: 'center'}}>Получение данных...</span>
				: (
					dict?.s?.body?.list?.length
					? dict?.s?.body?.list?.map(o => <Item doc={o} key={o._id} active={value === o.value?.[0]} selected={state === o.value?.[0]} onSelect={setState} submit={submit} />)
					: <span style={{textAlign: 'center'}}>Данные отсутствуют</span>
				)
			}
		</Content>
		<Footer>
			<Button type='base-reverse' onClick={close}>Отмена</Button>
			<Button disabled={!state} type='base' onClick={submit}>Выбрать</Button>
		</Footer>
	</Modal>
});

export default observer(Dict);